import moment from "moment";

export const isValidPhone = (phoneNumber) => {
    //const regexp = /^(\+)?((\d{2,3}) ?\d|\d)(([ -]?\d)|( ?(\d{2,3}) ?)){5,12}\d$/;
    const regexp = '^\+?[78][-\(]?\d{3}\)?-?\d{3}-?\d{2}-?\d{2}$';
    console.log(phoneNumber.match(regexp));
    return phoneNumber.match(regexp);
}

export const dateMustBeValid = (value) => {
    return moment(value, 'YYYY-MM-DD', true).isValid();
}

export let userPhotoUri = {
    uri: "",
    key: 0,
}
